export default "__VITE_ASSET__C6AWZ3XR__"